import { Columns } from '#types/grid';

export function getSelectedColumns(columns: Columns): Columns {
  const selectedColumns: Columns = [];

  for (const column of columns) {
    if (column.visible) {
      selectedColumns.push(column);
    }
  }

  return [...selectedColumns];
}
